import { translate } from "@/utils/translations"

export const humanizeBulkCodeCount = count => {
  if (count === 1) {
    return translate('order_history.bulk.available_code', { number: count })
  } else if (count > 1){
    return translate('order_history.bulk.available_codes', { number: count })
  }
}
